import DateRangeModal from './DateRangeModal';

export default DateRangeModal;
